import { render } from "./ProductKeysView.vue?vue&type=template&id=078fcc96&ts=true"
import script from "./ProductKeysView.vue?vue&type=script&lang=ts"
export * from "./ProductKeysView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__